const ALLOWED_INPUT_PATTERN = /[0-9.,\-$()a-zA-Z\s£€¥]/;

export const EXPENSE_AMOUNT_SEARCH_HELPER_TEXT =
    'Enter the exact amount. Amount searches Charge Amount and Allocated Amount.';

export const VAULT_AMOUNT_SEARCH_HELPER_TEXT =
    'Enter the exact amount. Amount searches the total amount shown in the list view.';

export const EXPENSE_AMOUNT_SEARCH_ERROR_TEXT =
    'Enter a valid amount with no more than 2 decimal places.';

/**
 * Filters expense amount search input to allowed characters while preserving
 * currency text, commas, and parentheses for display.
 */
export const valueAsExpenseAmountSearch = (value) => {
    if (!value) return '';

    return [...value].filter((char) => ALLOWED_INPUT_PATTERN.test(char)).join('');
};

/**
 * Parses amount search input into a normalized numeric string for the API.
 * Returns null when the value cannot be normalized to a valid amount.
 */
export const parseExpenseAmountSearch = (value) => {
    if (!value || typeof value !== 'string') return null;

    let working = value.trim();
    if (!working) return null;

    let isNegative = false;

    const wrappedInParens = working.match(/^\$?\(\s*(.+?)\s*\)$/);
    if (wrappedInParens) {
        isNegative = true;
        working = wrappedInParens[1].trim();
    }

    working = working
        .replace(/[a-zA-Z]/g, '')
        .replace(/[$,£€¥]/g, '')
        .replace(/[()]/g, '')
        .replace(/\s/g, '');

    if (!working || !/\d/.test(working)) return null;

    if (working.startsWith('-')) {
        isNegative = true;
        working = working.slice(1);
    }

    if (!working) return null;

    if (!/^\d+(\.\d+)?$/.test(working)) return null;

    const [, decimals] = working.split('.');
    if (decimals && decimals.length > 2) return null;

    return `${isNegative ? '-' : ''}${working}`;
};

/**
 * Returns true when the value can be normalized to a complete, searchable amount.
 */
export const isValidExpenseAmountSearch = (value) => parseExpenseAmountSearch(value) !== null;

/**
 * Normalizes display input for the API by stripping formatting and applying sign rules.
 */
export const normalizeExpenseAmountSearch = (value) => parseExpenseAmountSearch(value) ?? '';
